/**
 * อ่านว่า "หน้านี้เป็นของมูลนิธิไหน" จาก path ของตัวเอง
 *
 * ─── ทำไมอยู่ใน shared ──────────────────────────────────────────────────
 *
 * ทั้งสามเว็บ (admin, LIFF เจ้าหน้าที่, LIFF ผู้บริจาค) ต้องตีความ path
 * แบบเดียวกันเป๊ะ ถ้าแยกกันเขียนสามที่แล้ววันหนึ่งมีที่ไหนเพี้ยนไปตัวเดียว
 * ผลคือแอปนั้นคุยกับมูลนิธิผิดราย ซึ่งฝั่งผู้บริจาคแปลว่า **QR พร้อมเพย์
 * ชี้ไปบัญชีของอีกมูลนิธิ** และเป็นบั๊กที่ไม่มีอะไรฟ้องจนกว่าเงินจะเข้าผิดที่
 *
 * อยู่ตรงนี้แล้วเทสต์ได้ในชุดเดียวกับฝั่ง API ด้วย
 */

/** ไม่มี slug ในลิงก์ = มูลนิธิแรก — รองรับลิงก์รุ่นเก่าที่ยังไม่ได้แก้ endpoint */
export const DEFAULT_ORG_SLUG = 'main';

/**
 * ตรงกับกติกาของ slug ฝั่งฐานข้อมูล: ตัวอักษร/ตัวเลข/ขีด ยาวไม่เกิน 39
 *
 * ต้องเป็น regex ที่แคบ ไม่ใช่ `[^/]+` — path มาจากภายนอกเสมอ และค่านี้
 * ถูกเอาไปต่อเป็น URL ของ API ต่อ ถ้ารับอะไรก็ได้จะเปิดช่องให้ยิงข้าม path
 */
const SLUG_IN_PATH = /^\/o\/([a-z0-9][a-z0-9-]{0,38})(?=\/|$)/i;

export interface OrgLocation {
  slug: string;
  /** ค่าที่ต้องส่งให้ <BrowserRouter basename> — ว่างเมื่อลิงก์ไม่มี slug */
  basename: string;
  /** ลิงก์นี้ระบุมูลนิธิมาชัดเจนหรือไม่ (ใช้แยก "ระบุ main" ออกจาก "ไม่ได้ระบุ") */
  explicit: boolean;
}

export function parseOrgPath(pathname: string): OrgLocation {
  const m = SLUG_IN_PATH.exec(pathname);
  if (!m) return { slug: DEFAULT_ORG_SLUG, basename: '', explicit: false };

  const slug = m[1]!.toLowerCase();
  return { slug, basename: `/o/${slug}`, explicit: true };
}
